module.exports = __webpack_public_path__ + "img/feature-privacy.dbb97fe0.svg";